import type { Discussion } from "./types";
import { toneBadge, toneSolid } from "./tones";

export function formatNum(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;
}

export default function DiscussionCard({
  topic,
  rank,
  onOpen,
}: {
  topic: Discussion;
  rank?: number;
  onOpen: (t: Discussion) => void;
}) {
  return (
    <button
      type="button"
      onClick={() => onOpen(topic)}
      className="group w-full cursor-pointer rounded-2xl border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-200 hover:bg-white"
    >
      <div className="flex items-start gap-3">
        {typeof rank === "number" && (
          <span
            className={
              rank <= 3
                ? "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-white"
                : "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-background-100 text-base font-bold text-foreground-400"
            }
          >
            {rank}
          </span>
        )}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${toneBadge[topic.tagTone]}`}>{topic.categoryName}</span>
            <span className="rounded-md bg-primary-500 px-1.5 py-0.5 text-[11px] font-bold text-white">{topic.tag}</span>
          </div>
          <h3 className="mt-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[17px]">
            {topic.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>

          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className={`flex h-6 w-6 items-center justify-center rounded-full text-[10px] font-bold text-white ${toneSolid[topic.author.tone]}`}>
                {topic.author.initial}
              </span>
              <span className="font-medium text-foreground-700">{topic.author.name}</span>
              <span className="hidden sm:inline">· {topic.time}</span>
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line" aria-hidden="true"></i>
              {formatNum(topic.comments)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
              {topic.views}
            </span>
            <span className="ml-auto flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 font-semibold text-accent-800">
              热度 {topic.heat}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
}